<template>
  <div class="edit-video-box">
    <el-dialog
      :title="'用户编辑'"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="editParam" :rules="rules" label-width="140px">
        <div class="form_item">
          <el-form-item label="头像:" prop="portrait">
            <base-upload
              :cover="editParam.portrait"
              :action="action"
              @successCallback="successCallback"
              :wSize="360"
              :hSize="360"
            ></base-upload>
          </el-form-item>
          <el-form-item label="背景图:" prop="background">
            <base-upload
              :cover="editParam.background"
              :action="action"
              @successCallback="successCallback1"
              :wSize="360"
              :hSize="360"
            ></base-upload>
          </el-form-item>
        </div>
        <div class="form_item">
          <div>
            <el-form-item label="昵称:">
              <el-input v-model="editParam.name" size="small"></el-input>
            </el-form-item>
            <el-form-item label="VIP等级:" prop="vipLevel">
              <el-select
                v-model="editParam.vipLevel"
                size="small"
                :disabled="!auth"
              >
                <el-option
                  v-for="item in vipLevelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="VIP到期时间:" prop="vipExpireDate">
              <el-date-picker
                type="datetime"
                v-model="editParam.vipExpireDate"
                placeholder="选择日期时间"
                size="small"
                :disabled="!auth"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="金币视频免费时间:" prop="goldVideoFreeExpire">
              <el-date-picker
                type="datetime"
                v-model="editParam.goldVideoFreeExpire"
                placeholder="选择日期时间"
                size="small"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="金币视频折扣:" prop="payVidDiscount">
              <el-input
                v-model.number="editParam.payVidDiscount"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="城市:" prop="region">
              <el-input v-model="editParam.region" size="small"></el-input>
            </el-form-item>
            <el-form-item label="原创博主排序:" prop="originalSort">
              <el-input
                v-model.number="editParam.originalSort"
                size="small"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="加金币:" prop="amount">
              <el-input
                v-model.number="editParam.amount"
                size="small"
                :disabled="!auth"
              ></el-input>
              <el-button
                type="primary"
                size="small"
                style="marginLeft: 5px;"
                :disabled="!auth"
                @click="isAddUserGold('coin')"
                >确定</el-button
              >
            </el-form-item>
            <el-form-item label="增加AI脱衣次数:" prop="freeTimes">
              <el-input
                v-model.number="freeTimes"
                size="small"
                :disabled="!auth"
              ></el-input>
              <el-button
                type="primary"
                size="small"
                style="marginLeft: 5px;"
                :disabled="!auth"
                @click="isAddUserGold('freeTimes')"
                >确定</el-button
              >
            </el-form-item>
            <el-form-item label="增加下载次数:" prop="download">
              <el-input
                v-model.number="download"
                size="small"
                :disabled="!auth"
              ></el-input>
              <el-button
                type="primary"
                size="small"
                style="marginLeft: 5px;"
                :disabled="!auth"
                @click="isAddUserGold('download')"
                >确定</el-button
              >
            </el-form-item>
            <el-form-item label="私信价格:" prop="chatPrice">
              <el-input
                v-model.number="editParam.chatPrice"
                placeholder="负数为免费，填0则不修改"
                size="small"
              ></el-input>
              <br>
              <span style="color:red;font-size:10px;"
                >负数为免费，填0则不修改</span
              >
            </el-form-item>
            <el-form-item label="手机号码:" prop="mobile">
              <el-input v-model="editParam.mobile" size="small"></el-input>
            </el-form-item>
            <el-form-item label="绑定银行卡名称:" prop="mobile">
              <el-input v-model="editParam.bankActName" size="small"></el-input>
            </el-form-item>
            <el-form-item label="个人简介:">
              <el-input
                type="textarea"
                v-model="editParam.summary"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="商家账号:" prop="merchantAccount">
              <el-input
                v-model="editParam.merchantAccount"
                size="small"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form_item">
          <div>
            <el-form-item label="是否是大V:" prop="superUser">
              <el-select
                v-model="editParam.superUser"
                size="small"
                placeholder="请选择是否是大V"
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否官方认证:" prop="officialCert">
              <el-select
                v-model="editParam.officialCert"
                size="small"
                placeholder="请选择是否官方认证"
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="margin-left: 70px;"
              label="是否工作室:"
              prop="isMadou"
            >
              <el-select
                v-model="editParam.isMadou"
                size="small"
                placeholder="请选择是否工作室"
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              style="margin-left: 70px;"
              label="请选择视频扣税率: 用户获得(1-扣税率)"
              prop="taxLevel"
              class="item"
            >
              <el-select
                v-model="editParam.taxLevel"
                size="small"
                placeholder="请选择视频扣税率"
              >
                <el-option label="70%" :value="7"></el-option>
                <el-option label="60%" :value="6"></el-option>
                <el-option label="50%" :value="5"></el-option>
                <el-option label="40%" :value="4"></el-option>
                <el-option label="30%" :value="3"></el-option>
                <el-option label="20%" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form_item">
          <el-form-item label="视频扣量:" prop="videoDeduction">
            <el-select
              v-model="editParam.videoDeduction"
              size="small"
              placeholder="请选择视频扣量"
            >
              <el-option label="5%" :value="0.5"></el-option>
              <el-option label="10%" :value="1"></el-option>
              <el-option label="15%" :value="1.5"></el-option>
              <el-option label="20%" :value="2"></el-option>
              <el-option label="25%" :value="2.5"></el-option>
              <el-option label="30%" :value="3"></el-option>
              <el-option label="35%" :value="3.5"></el-option>
              <el-option label="40%" :value="4"></el-option>
              <el-option label="45%" :value="4.5"></el-option>
              <el-option label="50%" :value="5"></el-option>
              <el-option label="55%" :value="5.5"></el-option>
              <el-option label="60%" :value="6"></el-option>
              <el-option label="65%" :value="6.5"></el-option>
              <el-option label="70%" :value="7"></el-option>
            </el-select>
            <br />
            <span style="color:red;font-size:10px;"
              >扣量说明: 10%, 博主10单扣1单, 以此类推</span
            >
          </el-form-item>
          <el-form-item
            label="更改vip时间原因:"
            prop="vipReason"
            v-if="editParam.vipExpireDate !== editParam.initvipExpireDate"
          >
            <el-input
              type="textarea"
              v-model="editParam.vipReason"
              size="small"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          @click="restBankName"
          size="medium"
          class="restBankName"
          :loading="restLoading"
          >重置银行卡姓名</el-button
        >
        <el-button @click="handleClose" size="medium">取 消</el-button>
        <el-button
          type="primary"
          @click="handleOK()"
          :loading="flag"
          size="medium"
          >确 认</el-button
        >
      </div>
    </el-dialog>
    <!-- 增加金币 -->
    <el-dialog
      :title="dialogCoinVisibleTitle"
      :visible.sync="dialogCoinVisible"
      width="500px"
      :before-close="handleCoinClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="editParam" label-width="140px">
        <div class="form_item">
          <el-form-item
            v-if="dialogCoinVisibleTitle === '增加金币'"
            label="金币:"
          >
            <el-input v-model.number="editParam.amount" size="small"></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogCoinVisibleTitle === '增加果币'"
            label="果币:"
          >
            <el-input v-model.number="fruitCoin" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form_item">
          <el-form-item label="操作原因:">
            <el-input v-model="editParam.reason" size="small"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCoinClose" size="medium">取 消</el-button>
        <el-button
          type="primary"
          @click="addCoin()"
          :loading="flag"
          size="medium"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import { validatorCutNumber } from "@/utils/validator";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      uid: "",
      dialogVisible: false,
      dialogCoinVisible: false,
      dialogCoinVisibleTitle: "增加金币",
      flag: false,
      auth: true,
      // 用户头像上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      freeTimes: 0,
      download: 0,
      fruitCoin: 0,
      restLoading: false,
      editParam: {
        name: "",
        summary: "",
        vipLevel: "",
        vipExpireDate: "",
        goldVideoFreeExpire: "",
        initvipExpireDate: "",
        amount: "",
        reason: "",
        mobile: "",
        portrait: "",
        background: [],
        superUser: "",
        officialCert: "",
        isMadou: "",
        taxLevel: "",
        region: "",
        bankActName: "",
        originalSort: "",
        merchantAccount: "",
        payVidDiscount: 0,
        videoDeduction: 0,
        chatPrice: undefined,
        vipReason: "",
      },
      vipLevelList: [
        { value: 0, label: "非VIP" },
        { value: 1, label: "VIP" },
        { value: 2, label: "超级VIP" },
        { value: 3, label: "SSVIP" },
      ],
      rules: {
        vipLevel: [
          { required: true, message: "请输入VIP等级", trigger: "blur" },
          { type: "number", message: "vip等级必须为数字" },
        ],
        vipExpireDate: [
          { required: true, message: "请选择VIP到期时间", trigger: "blur" },
        ],
        // goldVideoFreeExpire: [
        //   { required: true, message: "请选择金币视频免费到期时间", trigger: "blur" },
        // ],
        originalSort: [
          {
            pattern: /^([1-9]\d|\d)$/,
            message: "请输入0-99的数字",
            trigger: "blur",
          },
        ],
        amount: [
          { required: true, message: "请输入金币", trigger: "blur" },
          { type: "number", message: "金币必须为数字" },
          { validator: validatorCutNumber, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // this.auth = validatorAuthority();
  },
  methods: {
    restBankName() {
      let params = {
        uid: this.uid,
        bankActName: "",
      };
      this.$confirm(
        `此操作将重置用户UID：<span style="color:red">${this.uid} </span>的银行卡姓名, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.restLoading = true;
          API.restBankUserName(params)
            .then((res) => {
              this.restLoading = false;
              if (res.code === 200) {
                this.$message({
                  message: "重置用户银行卡成功",
                  type: "success",
                });
                this.$emit("goBack");
              } else {
                this.$message.error("重置失败");
              }
              this.handleClose();
            })
            .catch(() => {
              this.restLoading = false;
              this.handleClose();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重置",
          });
        });
    },
    isAddUserGold(type) {
      this.dialogCoinVisible = true;
      if (type === "freeTimes") {
        this.dialogCoinVisibleTitle = "增加免费次数";
      }
      if (type === "download") {
        this.dialogCoinVisibleTitle = "增加下载次数";
      }
    },
    addCoin() {
      if (this.dialogCoinVisibleTitle === "增加金币") {
        this.addUserGold();
      } else if (this.dialogCoinVisibleTitle === "增加免费次数") {
        this.addAiFreeTimes();
      } else if (this.dialogCoinVisibleTitle === "增加下载次数") {
        this.addDownloadTimes();
      } else {
        this.$message.error("操作方法不存在!");
      }
    },
    // 加金币
    addUserGold() {
      if (this.editParam.amount == 0) {
        this.$message.error("金币不能为0");
        return;
      }
      if (this.editParam.reason == "") {
        this.$message.error("操作原因不能为空");
        return;
      }
      let params = {
        uid: this.uid,
        amount: this.editParam.amount,
        reason: this.editParam.reason,
      };
      API.addUserGold(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.editParam.amount = 0;
            this.$emit("goBack");
          } else {
            this.$message.error("操作失败!");
          }
          this.handleCoinClose();
        })
        .catch(() => {});
    },
    // 加果币
    addUserFruitCoin() {
      if (this.fruitCoin == 0) {
        this.$message.error("果币不能为0");
        return;
      }
      if (this.editParam.reason == "") {
        this.$message.error("操作原因不能为空");
        return;
      }
      let params = {
        uid: this.uid,
        fruitCoin: this.fruitCoin,
        reason: this.editParam.reason,
      };
      API.addUserFruitCoin(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.fruitCoin = 0;
            this.$emit("goBack");
          } else {
            this.$message.error("操作失败!");
          }
          this.handleCoinClose();
        })
        .catch(() => {});
    },
    // 加ai免费脱衣次数
    addAiFreeTimes() {
      if (this.freeTimes == 0) {
        this.$message.error("免费次数不能为0");
        return;
      }
      if (this.editParam.reason == "") {
        this.$message.error("操作原因不能为空");
        return;
      }
      let params = {
        uid: this.uid,
        freeTimes: this.freeTimes,
        mark: this.editParam.reason,
      };
      API.addAiUndressFreeTimes(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.freeTimes = 0;
            this.$emit("goBack");
          } else {
            this.$message.error("操作失败!");
          }
          this.handleCoinClose();
        })
        .catch(() => {});
    },
    // 加下载次数
    addDownloadTimes() {
      if (this.download == 0) {
        this.$message.error("下载次数不能为0");
        return;
      }
      if (this.editParam.reason == "") {
        this.$message.error("操作原因不能为空");
        return;
      }
      let params = {
        uid: this.uid,
        download: this.download,
        mark: this.editParam.reason,
      };
      API.addDownloadTimes(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.download = 0;
            this.$emit("goBack");
          } else {
            this.$message.error("操作失败!");
          }
          this.handleCoinClose();
        })
        .catch(() => {});
    },
    // 头像上传成功回掉
    successCallback(res) {
      this.editParam.portrait = res.data.coverImg;
    },
    successCallback1(res) {
      this.editParam.background = [res.data.coverImg];
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs["form"].resetFields();
      this.fruitCoin = 0;
      this.freeTimes = 0;
      this.download = 0;
    },
    handleCoinClose() {
      this.dialogCoinVisible = false;
      this.dialogCoinVisibleTitle = "增加金币";
    },
    // 确认修改
    handleOK() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.flag = true;
          this.submitEdit();
        } else {
          return false;
        }
      });
    },
    // 提交修改
    submitEdit() {
      if (this.editParam.vipExpireDate !== this.editParam.initvipExpireDate) {
        if (!this.editParam.vipReason) {
          this.$message.warning("请填写更改会员时间原因");
          this.flag = false;
          return;
        }
      } else {
        this.editParam.vipExpireDate = undefined;
      }
      let params = {
        uid: this.uid,
        vipLevel: parseInt(this.editParam.vipLevel),
        vipExpireDate: this.editParam.vipExpireDate,
        goldVideoFreeExpire: this.editParam.goldVideoFreeExpire,
        vipExpireDateModifyReason: this.editParam.vipReason,
        amount: this.editParam.amount,
        mobile: this.editParam.mobile ? this.editParam.mobile : "ZERO_VALUE",
        summary: this.editParam.summary,
        portrait: this.editParam.portrait,
        name: this.editParam.name,
        background: this.editParam.background,
        region: this.editParam.region,
        superUser: this.editParam.superUser,
        officialCert: this.editParam.officialCert,
        isMadou: this.editParam.isMadou,
        taxLevel: this.editParam.taxLevel,
        bankActName: this.editParam.bankActName
          ? this.editParam.bankActName
          : undefined,
        originalSort:
          this.editParam.originalSort != ""
            ? this.editParam.originalSort
            : undefined,
        chatPrice:
          this.editParam.chatPrice != "" ? this.editParam.chatPrice : undefined,
        merchantAccount:
          this.editParam.merchantAccount != ""
            ? this.editParam.merchantAccount
            : undefined,
        videoDeduction: this.editParam.videoDeduction,
        payVidDiscount: this.editParam.payVidDiscount,
      };
      API.editUser(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "用户信息修改成功",
              type: "success",
            });
            this.$emit("goBack");
          } else {
            this.$message.error("修改失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(row) {
      this.uid = row.uid;
      this.editParam.vipLevel = row.vipLevel;
      this.editParam.vipExpireDate = row.vipExpireDate;
      this.editParam.goldVideoFreeExpire = row.goldVideoFreeExpire;
      this.editParam.initvipExpireDate = row.vipExpireDate;
      this.editParam.amount = 0;
      this.editParam.mobile = row.mobile;
      this.dialogVisible = true;
      this.editParam.name = row.name;
      this.editParam.summary = row.summary;
      this.editParam.portrait = row.portrait;
      this.editParam.background = row.background;
      this.editParam.superUser = row.superUser;
      this.editParam.officialCert = row.officialCert;
      this.editParam.isMadou = row.isMadou;
      this.editParam.taxLevel = row.taxLevel;
      this.editParam.region = row.region;
      this.editParam.bankActName = row.bankActName;
      this.editParam.originalSort = row.originalSort;
      this.editParam.merchantAccount = row.merchantAccount;
      this.editParam.chatPrice = row.chatPrice;
      this.editParam.videoDeduction = row.videoDeduction;
      this.editParam.payVidDiscount = row.payVidDiscount;
    },
  },
};
</script>

<style lang="scss">
.edit-video-box {
  .el-input {
    width: 150px;
  }
}
.form_item {
  display: flex;
}
.item .el-form-item__label {
  line-height: 20px !important;
}
.dialog-footer {
  position: relative;
  text-align: center;
  // left: 10%;
  // transform: translate(-50%);
}
.restBankName {
  position: absolute !important;
  left: 0;
}
</style>
